var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(_vm.loading)?_c('loading'):_vm._e(),_c('v-divider'),_c('br'),_c('v-alert',{attrs:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.response)+" ")]),_c('v-divider'),_c('br'),_c('v-alert',{attrs:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]),_c('v-divider'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }